import { Badge } from '@monksflow/monks-ui';
import type { ContentTestListItemDto } from '@inference.engine/persona-api-client';
import { useTranslation } from 'react-i18next';

type Status = ContentTestListItemDto['status'];

const STATUS_CONFIG = {
  completed: { labelKey: 'contentTest.contentTestStatusChip.ready', variant: 'positive' },
  running: { labelKey: 'contentTest.contentTestStatusChip.inProgress', variant: 'warning' },
  draft: { labelKey: 'contentTest.contentTestStatusChip.draft', variant: 'secondary' },
  failed: { labelKey: 'contentTest.contentTestStatusChip.failed', variant: 'destructive' },
} as const satisfies Record<
  Status,
  { labelKey: string; variant: 'positive' | 'warning' | 'secondary' | 'destructive' }
>;

interface ContentTestStatusChipProps {
  status: Status;
}

export const ContentTestStatusChip = ({ status }: ContentTestStatusChipProps) => {
  const { t } = useTranslation('contentTest');
  const config = STATUS_CONFIG[status];

  return (
    <Badge variant={config.variant} roundness="full">
      {t(config.labelKey)}
    </Badge>
  );
};
